import IconTrees from './component.jsx'
export default IconTrees
